import imp from '@/lib/imp';
import { UvRoute } from '@/lib/router';

const route: UvRoute = {
  path: 'settings',
  name: 'admin.settings.index',
  component: imp(() => import('@/pages/admin/settings/Main.vue' /* webpackChunkName: 'admin.settings.index' */)),
  meta: {
    permissions: ['manage.settings'],
    header: {
      route: 'admin.settings.index',
      label: 'Setari',
    },
    breadcrumb: {
      label: 'Setari',
      route: 'admin.settings.index',
    },
  },
};

export default route;
